module.exports = __webpack_public_path__ + "media/img/user1-128x128-08af4cc7.jpg";